import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Americký fotbal",
    Baseball: "Baseball",
    Basketball: "Basketbal",
    Boxing: "Box",
    Chess: "Šachy",
    Cricket: "Kriket",
    Darts: "Šipky",
    Entertainment: "Zábava",
    "E-Sports": "E-Sports",
    Football: "Fotbal",
    "Formula 1": "Formule 1",
    "Gaelic Football": "Gaelský Fotbal",
    "Generic Sport": "Generický sport",
    Golf: "Golf",
    "Greyhound Racing": "Chrtí závody",
    Handball: "Házená",
    "Ice Hockey": "Lední hokej",
    IndyCar: "IndyCars",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politika",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Stolní tenis",
    Tennis: "Tenis",
    "Virtual Football": "Virtuální Fotbal",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} zvítězí",
    WinFirstRound: "{name} vyhraje první kolo",
    FirstTouchdown: "{name} dá touchdown jako první",
    FirstTry: "{name} dá pětku jako první",
    TotalGoals: "{name} celkem gólů",
    TotalRuns: "{name} celkem běhů",
    TotalPoints: "{name} celkem bodů",
    TopBatsman: "{name} se stane nejlepším pálkařem",
    TopBowler: "{name} se stane nejlepším nadhazovačem",
    FirstScore: "{name} vstřelí gól jako první"
  },
  PromoTexts: {
    Pick: "Tvůj výběr",
    Bet: "Sázka",
    Pays: "Výhra"
  },
  DateTimeTexts: {
    Today: "Dnes",
    Tomorrow: "Zítra",
    Live: "Živě"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Tvůj výběr",
    Return: "Výhra",
    Stake: "Sázka",
    Draw: "X"
  },
  H2HTexts: {
    // general
    "Per match": "na zápas",
    H2H: "H2H",
    W: "V",
    D: "R",
    L: "P",
    T: "R",

    // soccer
    goals_scored: "Vstřelené branky",
    shots: "Střely",
    shots_on_target: "Střely na bránu",
    ball_possession: "Držení míče",
    goals_conceded: "Obdržené branky",

    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
